import { render, staticRenderFns } from "./m-action-chip.vue?vue&type=template&id=1b83a2c1&scoped=true&"
import script from "./m-action-chip.vue?vue&type=script&lang=js&"
export * from "./m-action-chip.vue?vue&type=script&lang=js&"
import style0 from "./m-action-chip.vue?vue&type=style&index=0&id=1b83a2c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83a2c1",
  null
  
)

export default component.exports